import Icon from '@dtvgo/icon';
import MenuButton from '../MenuButton/MenuButton.js';
import VolumeBar from '../VolumeBar/VolumeBar.js';
import './VolumeButton.scss';
import { jsx } from 'react/jsx-runtime';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/createSuper';
import 'react';
import '../PlayerButton/PlayerButton.js';
import '../PlayerButton/PlayerButton.scss';
import '../ConditionalVisible/ConditionalVisible.js';
import '@babel/runtime/helpers/esm/objectSpread2';
import '@babel/runtime/helpers/esm/slicedToArray';
import '@dtvgo/classnames';
import '../ConditionalVisible/ConditionalVisible.scss';
import '../MenuButton/MenuButton.scss';
import '@dtvgo/slider';
import '../VolumeBar/VolumeBar.scss';

/* External */

function VolumeButton(_ref) {
  var handleToggleMute = _ref.handleToggleMute,
    isMuted = _ref.isMuted,
    setVolume = _ref.setVolume,
    volume = _ref.volume,
    tooltipUnMute = _ref.tooltipUnMute,
    tooltipMute = _ref.tooltipMute;
  var realIsMuted = isMuted || volume === 0;
  var iconName;
  if (volume >= 70) iconName = 'volume-max';else if (volume >= 35) iconName = 'volume-middle';else if (volume > 0) iconName = 'volume-min';else iconName = 'volume-mute';
  return /*#__PURE__*/jsx(MenuButton, {
    onClick: handleToggleMute,
    showOnClick: false,
    buttonContent: /*#__PURE__*/jsx(Icon, {
      name: iconName
    }),
    className: "dtv-common-c-volume-button",
    tooltip: realIsMuted ? tooltipUnMute : tooltipMute,
    children: /*#__PURE__*/jsx(VolumeBar, {
      setVolume: setVolume,
      volume: volume,
      isMuted: realIsMuted
    })
  });
}
VolumeButton.defaultProps = {
  handleToggleMute: function handleToggleMute() {},
  isMuted: false,
  setVolume: function setVolume() {},
  volume: 0,
  tooltipUnMute: '',
  tooltipMute: ''
};

export { VolumeButton as default };
//# sourceMappingURL=VolumeButton.js.map
